import { createAction } from "redux-actions";

export const RENDERED_IMAGE_LIST = "RENDERED_IMAGE_LIST";
export const renderedImageList = createAction(RENDERED_IMAGE_LIST);

export const RENDERED_IMAGE_SYNC = "RENDERED_IMAGE_SYNC";
export const renderedImageSync = createAction(RENDERED_IMAGE_SYNC);

export const RENDERED_IMAGE_DETAIL = "RENDERED_IMAGE_DETAIL";
export const renderedImageDetails = createAction(RENDERED_IMAGE_DETAIL);
